import * as React from 'react';
import styled from 'styled-components';
import { COLORS, ComponentS, ComponentTextStyle, ComponentXL, Tag, TagVariants } from '../../index';
import { ReactNode } from 'react';

export interface CardMiddleSectionProps {
  colorBandColor?: string;
  categoryIcon?: React.ReactNode;
  categoryLabel?: string;
  title: string;
  description?: string;
  tags?: CardTag[];
  row2Tags?: CardTag[];
  disabled?: boolean;
}

export interface CardTag {
  label: string;
  variant?: TagVariants;
  icon?: ReactNode
}

export const CardMiddleSectionContainer = styled.div`
  display: flex;
  flex-grow: 1;
  width: calc(100% - 32px);
  position: relative;
  flex-direction: column;
  padding: 16px;
  gap: 8px;

  .descriptionBlock {
    padding: 2px 0;
  }

  .titleBlock {
    padding: 2px 0;
  }
`;

export const CardMiddleSectionColorBandStyles = styled.div<{ $color: string }>`
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  height: 8px;
  background-color: ${(props) => props.$color};
`;

export const CardMiddleSectionTagsStyles = styled.div`
  display: flex;
  flex-direction: row;
  padding: 4px 0;
  gap: 4px;
  flex-wrap: wrap;
`;

export const CardMiddleSectionCategoryStyles = styled.div<{ extraTopMargin: boolean; bottomMargin: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: none;
  gap: 6px;

  svg {
    color: ${COLORS.neutral_500};
    flex-grow: 0;
    flex-shrink: 0;
  }
`;

const CardMiddleSection: React.FunctionComponent<CardMiddleSectionProps> = ({
  colorBandColor,
  categoryIcon,
  categoryLabel,
  title,
  description,
  tags,
  row2Tags,
  disabled,
}: CardMiddleSectionProps) => {
  return (
    <CardMiddleSectionContainer data-testid={'card-middleSection'} >
      {colorBandColor && <CardMiddleSectionColorBandStyles $color={colorBandColor} />}
      {
        (categoryIcon || categoryLabel) &&
        <CardMiddleSectionCategoryStyles extraTopMargin={Boolean(colorBandColor)} bottomMargin={Boolean(categoryIcon || categoryLabel)}>
          {categoryIcon}
          <ComponentS textStyle={ComponentTextStyle.Bold} color={COLORS.neutral_500}>
            {categoryLabel}
          </ComponentS>
        </CardMiddleSectionCategoryStyles>
      }
      <ComponentXL className="titleBlock" textStyle={ComponentTextStyle.Bold} color={disabled ? COLORS.neutral_500 : COLORS.black}>
        {title}
      </ComponentXL>
      {description && (
        <ComponentS className="descriptionBlock" color={COLORS.neutral_600}>
          {description}
        </ComponentS>
      )}
      {tags && (
        <CardMiddleSectionTagsStyles>
          {tags.map((x, index) => (
            <Tag key={`${x.label}_${index}`} label={x.label} variant={x.variant ?? 'neutral'} icon={x.icon} />
          ))}
        </CardMiddleSectionTagsStyles>
      )}
      {row2Tags && (
        <CardMiddleSectionTagsStyles>
          {row2Tags.map((x, index) => (
            <Tag key={`${x.label}_${index}`} label={x.label} variant={x.variant ?? 'neutral'} icon={x.icon} />
          ))}
        </CardMiddleSectionTagsStyles>
      )}
    </CardMiddleSectionContainer>
  );
};

export default CardMiddleSection;
